/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Crown = (props: IconProps) => (
  <Icon {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M20.4593 9.01783C20.0543 8.7228 19.5125 8.67363 19.057 8.88963L15.887 10.4051L13.1814 5.63033C12.7062 4.78916 11.2931 4.78916 10.8197 5.63033L8.11408 10.4051L4.94406 8.88963C4.49043 8.67363 3.94499 8.7228 3.54177 9.01783C3.13494 9.31461 2.93332 9.80631 3.01973 10.2945L4.35002 17.9036C4.46163 18.5358 5.02327 18.9995 5.68031 18.9995H18.319C18.976 18.9995 19.5395 18.5358 19.6493 17.9036L20.9796 10.2945C21.0678 9.80807 20.8661 9.31461 20.4593 9.01783Z" />
  </Icon>
);
